"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const signature_1 = require("../signature");
const grain_1 = require("../util/grain");
class JoinNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'join') {
            let node = new JoinNode(obj['joinType']);
            if (obj['overrides']) {
                node.overrides = obj['overrides'].map(or => [signature_1.ColumnSignature.from(or[0]), signature_1.ColumnSignature.from(or[1])]);
            }
            return node;
        }
        return null;
    }
    constructor(joinType) {
        super('Join node');
        this.joinType = joinType;
        this.overrides = [];
    }
    override(col1, col2) {
        this.overrides.push([col1, col2]);
    }
    getSignature(datasetRepo) {
        if (!this.incoming.length)
            return null;
        if (!this.incoming[0])
            return this.incoming[1].getSignature(datasetRepo);
        if (!this.incoming[1])
            return this.incoming[0].getSignature(datasetRepo);
        let signature = new signature_1.default();
        let s1 = this.incoming[0].getSignature(datasetRepo);
        let s2 = this.incoming[1].getSignature(datasetRepo);
        signature.columns = s1.columns.concat(s2.columns);
        let grains = Array.from(s1.grains);
        s2.grains.forEach(grain => {
            if (!grains.find(g => g.equals(grain)))
                grains.push(grain);
        });
        signature.grains = grains;
        return signature;
    }
    checkPort(portNumber) {
        return portNumber === 0 || portNumber === 1;
    }
    validate(datasetRepo) {
        if (!this.incoming[0] || !this.incoming[1])
            return false;
        if (!this.incoming[0].validate(datasetRepo) || !this.incoming[1].validate(datasetRepo))
            return false;
        let sig1 = this.getIncoming(0).getSignature(datasetRepo);
        let sig2 = this.getIncoming(1).getSignature(datasetRepo);
        if (this.overrides.length) {
            for (let override of this.overrides) {
                if (!sig1.containsColumn(override[0]))
                    return false;
                if (!sig2.containsColumn(override[1]))
                    return false;
            }
            return true;
        }
        let common = (0, grain_1.grainSubset)(sig1.grains, sig2.grains);
        return !!common.length;
    }
    serialize() {
        let obj = super.serialize({
            type: 'join',
            joinType: this.joinType,
        });
        if (this.overrides.length) {
            obj['overrides'] = this.overrides.map(or => or.map(c => c.serialize()));
        }
        return obj;
    }
}
exports.default = JoinNode;
